import { useSiteLocale } from '../../hooks/useLocalizedNavigate';
import { useLocation, Navigate } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';
import { PageLoader } from '../common';

function RequireAuth({ children }: { children: JSX.Element }) {
    const auth = useAppSelector(state => state.auth);
    const location = useLocation();
    const locale = useSiteLocale();

    if (auth.meIsLoading) return <PageLoader />;

    if (!auth.authData && !auth.meIsLoading) {

        return (
            <Navigate
                to={`/${locale}/login`}
                state={{ from: location }}
                replace
            />
        );
    }

    return children;
}

export default RequireAuth;
